import { ColumnConfig } from '../../../../features/ui-config'

export function getDataType(dataType: ColumnConfig['dataType']) {
  switch (dataType) {
    case 'day':
    case 'decimal':
    case 'percent':
    case 'number':
    case 'price':
      return 'numeric'
    case 'date':
      return 'date'
    case 'active':
    case 'alcType':
    case 'attachmentCategory':
    case 'attachmentStatus':
    case 'boolean':
    case 'currency':
    case 'deliveryStatus':
    case 'deliveryType':
    case 'role':
    case 'packagingIdentifier':
    case 'packagingType':
    case 'project':
    case 'propertyIdentifier':
    case 'status':
    case 'string':
    case 'unitOfWeight':
    default:
      return 'text'
  }
}
